var _defs, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 252.50275,
    viewBox: "0 0 132.29165 66.808017",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(2.5329589e-6,-230.1919)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 36.777084,
    y: 111.2625,
    id: "text12"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan14",
    x: 36.777084,
    y: 121.05208
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 66.410416,
    y: 130.04791,
    id: "text18"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan16",
    x: 66.410416,
    y: 139.83749,
    style: {
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1D2",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "360.46774292px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 9.011693
    },
    id: "text22"
  }, /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1F1\\uE1FA\\uE1F3\\uE1F8\\uE1F8\\uE1F5",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "81.97303009px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 18.4678936
    },
    id: "text4082"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4094",
    style: {
      strokeWidth: 18.4678936
    },
    d: "m 109.83105,230.1919 v 8.19731 h 20.49326 v 4.01668 h -20.49326 v 8.1973 h 20.49326 v 29.51029 c -1.31157,-1.06565 -3.11498,-1.72143 -5.24627,-1.72143 -8.11533,0 -14.5912,5.98403 -14.5912,12.37792 0,3.85274 3.11497,6.14798 7.13165,6.14798 6.55784,0 14.5912,-6.066 14.67317,-12.29595 v -54.4301 z m 0.36631,0 H 87.736753 v 8.19731 h 22.460607 z m -22.094289,0 h -22.46061 v 8.19731 h 22.46061 z m -44.554902,0 v 8.19731 h 20.493258 v 41.72427 c -1.311568,-1.06565 -3.114975,-1.72143 -5.246274,-1.72143 -8.11533,0 -14.591199,5.98403 -14.591199,12.37792 0,3.85274 3.114975,6.14798 7.131653,6.14798 6.557843,0 14.5912,-6.066 14.673173,-12.29595 v -54.4301 z m 0.366317,12.21399 h -22.46061 v 8.1973 h 22.46061 z m 0,-12.21399 h -22.46061 v 8.19731 h 22.46061 z m -24.077015,50.00355 c -1.311569,-1.06565 -3.114975,-1.72143 -5.246274,-1.72143 -8.1153302,0 -14.5911995329589,5.98403 -14.5911995329589,12.37793 0,3.85273 3.1149751329589,6.14797 7.1316536329589,6.14797 6.5578419,0 14.5911989,-6.14797 14.6731719,-12.29595 V 230.1919 h -1.967352 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSes);
export default __webpack_public_path__ + "static/media/ses.a654481faeda08113d8aa27acec10d13.svg";
export { ForwardRef as ReactComponent };